/**
 * Detects errors that are caused by Firefox on iOS
 *
 * @param {object} report The report object
 * @returns {boolean} Returns true if the report matches
 * @example
 *   "null is not an object (evaluating 'article.element')"
 *   "Can't find variable: loadHomepageTiles"
 *   "Can't find variable: uiWebview_RemoveAllHighlights"
 */
function mobileFirefoxError(report) {
  if (
    report.errorMessage.includes("article.element") ||
    report.errorMessage.includes("loadHomepageTiles") ||
    report.errorMessage.includes("uiWebview_RemoveAllHighlights")
  ) {
    report.groupingHash = "MobileFirefoxError";

    return true;
  }

  return false;
}

export default mobileFirefoxError;
